import BaseRequestEditorMixin from "@/modules/core/request/protected/BaseRequestEditorMixin";
import service from "./CreditAssignmentRequestService";
import RequestForm from "./CreditAssignmentRequestForm";

export default {
  mixins: [BaseRequestEditorMixin],

  created() {
    this.RequestForm = RequestForm;
    this.requestContextServerPath = "credit-assignments/requests";
    //this.externalContext = 'CREDIT_ASSIGNMENT_REQUEST';
  },

  methods: {
    getService() {
      return service;
    }
  }
};
